import { updateIsCompletedEstimate } from './estimate.slice';

import { AppStartListening } from '~/redux/listenerMiddleware';
import * as colorAction from '~/redux/slices/color/color.slice';
import * as drawingShapeAction from '~/redux/slices/drawingShape/drawingShape.slice';
import * as materialAction from '~/redux/slices/material/material.slice';
import * as shapeAction from '~/redux/slices/shape/shape.slice';
import * as undoStackAction from '~/redux/slices/undoStack/undoStack.slice';

const resetCompletedEstimateActions = [
  materialAction.updateSelectedMaterial.type,
  materialAction.resetSelectedMaterial.type,

  colorAction.updateSelectedColorId.type,
  colorAction.resetSelectedColorId.type,

  shapeAction.updateSelectedDrawingObjectName.type,
  shapeAction.resetSelectedPredefinedShape.type,
  shapeAction.updateSelectedPredefinedShape.type,
  drawingShapeAction.updateNeedRedrawCanvas.type,
  drawingShapeAction.setActiveDrawingObject.type,

  undoStackAction.pushOperationUndoStack.type,
  undoStackAction.addUserDesignOperation.type,
];

export const setEstimateCompletedListener = (
  startListening: AppStartListening
) => {
  startListening({
    predicate: (action, currState) =>
      resetCompletedEstimateActions.includes(action.type) &&
      currState.estimate.isCompletedEstimate === true,
    effect: (_action, api) => {
      api.dispatch(updateIsCompletedEstimate(false));
    },
  });
};
